<mat-drawer-container style="height: 100vh">
    <mat-drawer mode="over" #userMenuDrawer position="end" style="min-width: 75vw">
        <div class="flex flex-col h-full">
            <div class="flex-auto" style="padding: 0 1em">
                <h4 style="margin-bottom: 0.5em">{{ userAccountDisplayName() }}</h4>
                <p class="text-sm">{{ userAccountEmail() }}</p>
            </div>
            <div class="flex flex-col gap-2">
                <div style="padding: 0 0.3rem">
                    <mat-button-toggle-group [(ngModel)]="darkModeIsEnabled" hideSingleSelectionIndicator="true" style="width: 100%">
                        <mat-button-toggle [value]="false" style="width: 50%">
                            <mat-icon>light_mode</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle [value]="true" style="width: 50%">
                            <mat-icon>dark_mode</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <mat-nav-list style="padding: 0">
                    @if (showSetDebugAndDevButtons()) {
                        <mat-divider />
                        <a mat-list-item routerLink="/set-debug"><mat-icon matListItemIcon>admin_panel_settings</mat-icon>Set debug</a>
                        <a mat-list-item routerLink="/dev-world"><mat-icon matListItemIcon>bug_report</mat-icon>Dev</a>
                    }
                    <mat-divider />
                    <mat-list-item role="listitem" (click)="onLogoutButtonClick()"
                        ><mat-icon matListItemIcon>logout</mat-icon>Uitloggen</mat-list-item
                    >
                </mat-nav-list>
            </div>
        </div>
    </mat-drawer>
    <mat-drawer-content class="flex! flex-col">
        <ng-content />
    </mat-drawer-content>
</mat-drawer-container>
